import React, { Component } from 'react';
import { Container, Form, Row} from 'react-bootstrap';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../../Config/Theme';

const Div = styled.div`
    background-color: white;
    color: black;
`

class Strategy extends Component{

    render() {
        return (
            <ThemeProvider theme={theme}>
                <Div>
                    <Container>
                        <Form className="p-3">
                            
                            <div className="form-section">
                                <h4>Strategy & Change</h4>
                                <hr />
                                <p>A strategic plan is an organization’s documented plan or vision for the direction of the organization as well as the overarching goals and steps needed to achieve that vision.</p>
                                
                                <Form.Group
                                className="ml-3"
                                name="formStrategicPlan"
                                as={Row}
                                controlId="formStrategicPlan"
                                onChange={this.props.handleChange}
                                >
                                    <Form.Label column sm={5}>
                                        27. Does the organization have a strategic plan?
                                    </Form.Label>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="Yes"
                                        value="yes"
                                        name="formStrategicPlan"
                                        id="formStrategicPlan-Yes"
                                        defaultChecked={
                                        this.props.formStrategicPlan === "yes"
                                        }
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="No"
                                        value="no"
                                        name="formStrategicPlan"
                                        id="formStrategicPlan-No"
                                        defaultChecked={
                                        this.props.formStrategicPlan === "no"
                                        }                               
                                    />
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="Unknown"
                                        value="unknown"
                                        name="formStrategicPlan"
                                        id="formStrategicPlan-NA"
                                        defaultChecked={
                                        this.props.formStrategicPlan === "unknown"
                                        }
                                    />
                                </Form.Group>

                                
                                <p>If yes:</p>
                                <p className="font-italic font-weight-bold">
                                On a scale from 1 to 5 (1-Not at all and
                                5-Very Well...)
                                </p>

                                <Form.Group
                                as={Row}
                                name="formUnderstandPlan"
                                controlId="formUnderstandPlan"
                                onChange={this.props.handleChangeAsInt}
                                >
                                <Form.Label column sm={5}>
                                    i. How well do you understand the strategic plan for your organization?
                                </Form.Label>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="1"
                                    value="1"
                                    name="formUnderstandPlan"
                                    id="formUnderstandPlan-1"
                                    defaultChecked={this.props.formUnderstandPlan === 1}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="2"
                                    value="2"
                                    name="formUnderstandPlan"
                                    id="formUnderstandPlan-2"
                                    defaultChecked={this.props.formUnderstandPlan === 2}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="3"
                                    value="3"
                                    name="formUnderstandPlan"
                                    id="formUnderstandPlan-3"
                                    defaultChecked={this.props.formUnderstandPlan === 3}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="4"
                                    value="4"
                                    name="formUnderstandPlan"
                                    id="formUnderstandPlan-4"
                                    defaultChecked={this.props.formUnderstandPlan === 4}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="5"
                                    value="5"
                                    name="formUnderstandPlan"
                                    id="formUnderstandPlan-5"
                                    defaultChecked={this.props.formUnderstandPlan === 5}
                                />
                                </Form.Group>
                                
                            </div>
                        </Form>
                    </Container>
                </Div>
            </ThemeProvider>
        )
    }
}

export default Strategy;